import { useEffect, useState, useCallback } from "react";
import { RefreshCw, ShieldCheck } from "lucide-react";
import api from "@/lib/api";

// Lightweight, accessible human check: a short text question + hidden honeypot field.
export default function CaptchaCheck({ value, onChange, refreshKey = 0, testid = "captcha" }) {
  const [question, setQuestion] = useState("");
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/captcha");
      setQuestion(data.question);
      onChange({ token: data.token, answer: "", website: "" });
    } catch { setQuestion(""); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load, refreshKey]);

  return (
    <div className="rounded-xl border border-[#E5E0D8] bg-white/60 px-3.5 py-3" data-testid={testid}>
      <label htmlFor={`${testid}-answer`} className="flex items-center gap-1.5 text-xs text-[#4A5D6B] mb-1.5">
        <ShieldCheck size={14} className="text-[#5C8A72]" aria-hidden="true" /> Quick check: <b className="text-[#1A242B]" data-testid={`${testid}-question`}>{question || "Loading…"}</b>
      </label>
      <div className="flex gap-2">
        <input id={`${testid}-answer`} inputMode="numeric" disabled={!question} autoComplete="off" aria-label={question || "Security question answer"}
          value={value?.answer || ""} onChange={(e) => onChange({ ...value, answer: e.target.value })}
          placeholder="Your answer" data-testid={`${testid}-answer`} className="eyw-input flex-1" />
        <button type="button" onClick={load} aria-label="Get a different question" data-testid={`${testid}-refresh`}
          className="grid place-items-center h-11 w-11 rounded-full border border-[#E5E0D8] text-[#144F75] hover:bg-[#144F75]/5">
          <RefreshCw size={15} />
        </button>
      </div>
      <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" value={value?.website || ""}
        onChange={(e) => onChange({ ...value, website: e.target.value })}
        style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} data-testid={`${testid}-hp`} />
    </div>
  );
}
